import { crudTable, date, index, text } from "@-/dev.improve.haniverse.lib.database.table";

// Per-user state for an authored slide (keyed by its catalogue UUID `key`). One row per `key`:
// the row id is derived from it (`deriveUserSlideId`), so two devices that touch the slide before
// they sync write the same row. No unique index guards `key`, and none may be added (sync cannot
// resolve a unique conflict). The row holds both:
//   - `completed_at`: when the user finished viewing it, so the Learn resolver
//     can skip slides already seen. Null until completed.
//   - `favorited_at`: when the user favorited it, so they can come back to it
//     later from the Favorite Slides settings page. Null when not favorited.
// Either timestamp may be set independently — a slide can be favorited before
// it is completed, and stays favorited after — so both are nullable and the row
// merely exists once a user has interacted with the slide in either way.
export const userSlideTable = crudTable(
  "user_slide",
  {
    completedAt: date("completed_at"),
    favoritedAt: date("favorited_at"),
    key: text("key").notNull(),
  },
  (table) => [index("user_slide_key_idx").on(table.key)],
);

export type UserSlide = typeof userSlideTable.$inferSelect;
